import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getAuth, isSignInWithEmailLink, signInWithEmailLink, UserCredential } from "firebase/auth";

const auth = getAuth();

export const useCheckSignIn = () => {
  const [result, setResult] = useState<UserCredential>();
  const [isChecking, setIsChecking] = useState(true);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.
      let email = window.localStorage.getItem('emailForSignIn');
      if (!email) {
        // User opened the link on a different device. To prevent session fixation
        // attacks, ask the user to provide the associated email again. For example:
        email = window.prompt('확인을 위해 이메일을 입력해 주세요.') || '';
      }
      // The client SDK will parse the code from the link for you.
      signInWithEmailLink(auth, email, window.location.href)
        .then((result) => {
          // Clear email from storage.
          window.localStorage.removeItem('emailForSignIn');
          // You can access the new user via result.user
          // Additional user info profile not available via:
          // result.additionalUserInfo.profile == null
          // You can check if the user is new or existing:
          // result.additionalUserInfo.isNewUser
          setResult(result);
        })
        .catch((error) => {
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
          setError(error);
        })
        .finally(() => {
          setIsChecking(false);
        });
    }
  }, []);

  return { result, error, isChecking };
};

export const useCountDownRedirection = (isSuccess: boolean) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [remain, setRemain] = useState(3);
  const redirection = decodeURIComponent(searchParams.get('redirection') || '');

  useEffect(() => {
    if (!isSuccess) { return }

    const id = window.setInterval(() => {
      if (remain === 0) {
        window.clearInterval(id);
        navigate(redirection);
        return;
      } else {
        setRemain(remain - 1);
      }
    }, 1000);
    return () => {
      window.clearInterval(id);
    }
  }, [navigate, redirection, remain, isSuccess]);

  return { remain, redirection };
}